import LightweightChart from "@/components/ui/lightweightChart";
import { Card } from "@/components/ui/card";
import TrendingStrategies from "./components/TrendingStrategynew";
import TrendingTraders from "./components/TrendingTradersNew";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useDarkTheme } from "@/contexts/DarkTheme";
import TrendingStrategy from "./components/TrendimgStrategies";
import { useToastHelper } from "@/helpers/helperFunctions";
import { useTranslation } from "next-i18next";
import React, { useEffect, useState } from "react";
import ViewModal from "./components/StrategyViewModal";
import CreateStrategyForm from "@/components/common/CreateStrategyForm";
import { useRecoilState } from "recoil";
import {
  selectedTimeFrameState,
  setSelectedSymbolState,
} from "@/Atoms/strategy/StrategyFormAtom";
import { CURRENT_DEFAULT_SYMBOL } from "@/config/logos";
import TradingViewLightweight from "@/components/ui/lightweightChart";
import TradingGraph from "@/components/charts/TradingGraph";
import CanvasIframe from "@/components/canvas/CanvasIframe";
import { useMediaQuery } from "@react-hook/media-query";
import { BUILD_CANVAS_STRATEGY } from "@/config/logos";

interface IFormValues {
  symbol?: string;
  timeframe?: string;
  strategy_name?: string;
}

const Section1 = ({ userInfo }: any) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [logos, setLogos] = useState<any>(new Map());
  const { darkTheme } = useDarkTheme();
  const [selected, setSelected] = useState<any>({});

  const [showGuideModal, setShowGuideModal] = useState(false);

  const toastNotify = useToastHelper();
  const { t } = useTranslation("build");
  const [guideModalURL, setGuideModalURL] = useState("");
  const [showStrategiesDrawer, setShowStrategiesDrawer] = useState(false);

  const [selectedSymbol] = useRecoilState(setSelectedSymbolState);
  const [selectedTimeFrame] = useRecoilState(selectedTimeFrameState);
  const isMobile = useMediaQuery("only screen and (max-width: 965px)");

  const setGuideModal = (url: string) => {
    setShowGuideModal(true);
    setGuideModalURL(url);
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      // @ts-ignore
      window.toastNotify = toastNotify;
      return () => {
        // @ts-ignore
        delete window.toastNotify;
      };
    }
  }, [toastNotify]);

  const getNameInitials = (name: any) => {
    const initials = name
      .split(" ")
      .slice(0, 2)
      .map((word: any) => word.charAt(0))
      .join("");
    return initials.toUpperCase();
  };

  return (
    <div id="create-new-strategy-form">
      <ViewModal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        selected={selected}
        token={userInfo?.token}
      />
      <TrendingStrategy
        userInfo={userInfo}
        t={t}
        show={showStrategiesDrawer}
        setShow={setShowStrategiesDrawer}
        logos={logos}
        darkTheme={darkTheme}
        getNameInitials={getNameInitials}
      />

      <Dialog
        open={showGuideModal}
        onOpenChange={() => setShowGuideModal(false)}
      >
        <DialogContent className="max-w-screen-xl w-full">
          <div className="sl-embed relative mt-4 pb-[calc(50.84%+27px)] w-full h-0 scale-100">
            <iframe
              className="sl-demo absolute top-0 left-0 w-full h-full border shadow-[0_0_18px_rgba(26,19,72,0.15)] rounded-lg box-border"
              src={guideModalURL}
              name="sl-embed"
              allow="fullscreen; camera; microphone"
            ></iframe>
          </div>
        </DialogContent>
      </Dialog>

      <div className="flex md:flex-row md:flex-nowrap flex-wrap gap-5 my-5 w-full">
        <Card className={"w-full lg:w-[795px] lg:max-w-[24rem]"}>
          <CreateStrategyForm />
        </Card>

        <Card className={"w-full lg:w-[100%-504px]  h-auto rounded-xl p-2"}>
          <div className="flex flex-col gap-2 items-center justify-center rounded-xl h-80 md:h-full  w-full">
            {isMobile || (selectedSymbol && selectedTimeFrame) ? (
              <div className="w-full  h-full build-page mt-[-10px] relative ">
                <TradingGraph
                  symbol={selectedSymbol ?? CURRENT_DEFAULT_SYMBOL}
                  timeframe={
                    selectedTimeFrame?.tradingViewValue
                      ? `${selectedTimeFrame?.tradingViewValue}m`
                      : "60m"
                  }
                ></TradingGraph>

                <div id="chart_widget" tabIndex={-1}></div>
              </div>
            ) : (
              <CanvasIframe
                src={`/demo?keygen=${BUILD_CANVAS_STRATEGY}`}
              ></CanvasIframe>
            )}
          </div>
        </Card>
      </div>
      <div className="flex flex-col w-full h-full lg:flex-row justify-between">
        <div className="w-full lg:w-[49%]">
          <TrendingTraders />
        </div>
        <div className="w-full lg:w-[49%] mt-5 lg:mt-0">
          <TrendingStrategies />
        </div>
      </div>
    </div>
  );
};
export default Section1;
